var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('RAFTFullScreenContent', {
    staticClass: "bio-space-listing",
    attrs: {
      "header-text": "Bio Material Exposures"
    },
    scopedSlots: _vm._u([{
      key: "topleft",
      fn: function () {
        return [_vm.isDownloading ? _c('RaftBusy', {
          attrs: {
            "busy-text": "Generating file"
          }
        }) : _c('VActionButton', {
          attrs: {
            "show-badge": false,
            "show-icon": false,
            "label": "Download History"
          },
          on: {
            "click": _vm.downloadExposureListing
          }
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('BaseFilters', {
    attrs: {
      "filters": _vm.filters,
      "is-busy": !_vm.componentReady
    },
    on: {
      "update-filters": _vm.updateFilters
    }
  }), _vm._v(" "), _vm.componentReady ? _c('BaseTable', {
    ref: "table",
    attrs: {
      "items": _vm.items,
      "fields": _vm.fields,
      "total-items": _vm.totalMaterials,
      "current-page": _vm.currentPageValue,
      "is-busy": _vm.isBusy,
      "no-local-sorting": false
    },
    on: {
      "update-current-page": _vm.updateCurrentPage
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function () {
        return [_c('div', {
          staticClass: "empty-text"
        }, [_vm._v("\n        There are currently no biological materials to list.\n      ")])];
      },
      proxy: true
    }, {
      key: "internal-link",
      fn: function (row) {
        return [_c('a', {
          attrs: {
            "href": row.data.value.url
          }
        }, [_vm._v(_vm._s(row.data.value.text))])];
      }
    }, {
      key: "biomaterial",
      fn: function (row) {
        var _row$data, _row$data$value, _row$data2, _row$data2$value, _row$data2$value$type, _row$data3, _row$data3$value, _row$data4, _row$data4$value, _row$data4$value$bio_, _row$data5;
        return [_vm._v("\n      " + _vm._s(row === null || row === void 0 ? void 0 : (_row$data = row.data) === null || _row$data === void 0 ? void 0 : (_row$data$value = _row$data.value) === null || _row$data$value === void 0 ? void 0 : _row$data$value.name) + "\n      "), _c('BioMaterialDataWindow', {
          attrs: {
            "material-type": row === null || row === void 0 ? void 0 : (_row$data2 = row.data) === null || _row$data2 === void 0 ? void 0 : (_row$data2$value = _row$data2.value) === null || _row$data2$value === void 0 ? void 0 : (_row$data2$value$type = _row$data2$value.type) === null || _row$data2$value$type === void 0 ? void 0 : _row$data2$value$type.substring(14),
            "bio-uuid": row === null || row === void 0 ? void 0 : (_row$data3 = row.data) === null || _row$data3 === void 0 ? void 0 : (_row$data3$value = _row$data3.value) === null || _row$data3$value === void 0 ? void 0 : _row$data3$value.id,
            "material-type-label": row === null || row === void 0 ? void 0 : (_row$data4 = row.data) === null || _row$data4 === void 0 ? void 0 : (_row$data4$value = _row$data4.value) === null || _row$data4$value === void 0 ? void 0 : (_row$data4$value$bio_ = _row$data4$value.bio_material_type) === null || _row$data4$value$bio_ === void 0 ? void 0 : _row$data4$value$bio_.label,
            "additional-id": String(row === null || row === void 0 ? void 0 : (_row$data5 = row.data) === null || _row$data5 === void 0 ? void 0 : _row$data5.index)
          }
        })];
      }
    }, {
      key: "project",
      fn: function (row) {
        var _row$data$value2, _row$data6, _row$data6$value;
        return [_c('b-link', {
          attrs: {
            "href": '/node/' + ((_row$data$value2 = row.data.value) === null || _row$data$value2 === void 0 ? void 0 : _row$data$value2.drupal_internal__nid)
          }
        }, [_vm._v("\n        " + _vm._s(row === null || row === void 0 ? void 0 : (_row$data6 = row.data) === null || _row$data6 === void 0 ? void 0 : (_row$data6$value = _row$data6.value) === null || _row$data6$value === void 0 ? void 0 : _row$data6$value.title) + "\n      ")])];
      }
    }, {
      key: "group",
      fn: function (row) {
        var _row$data$value$, _row$data7, _row$data7$value, _row$data7$value$;
        return [_c('b-link', {
          attrs: {
            "href": '/node/' + ((_row$data$value$ = row.data.value[0]) === null || _row$data$value$ === void 0 ? void 0 : _row$data$value$.drupal_internal__nid)
          }
        }, [_vm._v("\n        " + _vm._s(row === null || row === void 0 ? void 0 : (_row$data7 = row.data) === null || _row$data7 === void 0 ? void 0 : (_row$data7$value = _row$data7.value) === null || _row$data7$value === void 0 ? void 0 : (_row$data7$value$ = _row$data7$value[0]) === null || _row$data7$value$ === void 0 ? void 0 : _row$data7$value$.title) + "\n      ")])];
      }
    }, {
      key: "researcher",
      fn: function (row) {
        var _row$data$value3, _row$data8, _row$data8$value;
        return [_c('b-link', {
          attrs: {
            "href": '/user/' + ((_row$data$value3 = row.data.value) === null || _row$data$value3 === void 0 ? void 0 : _row$data$value3.drupal_internal__uid)
          }
        }, [_vm._v("\n        " + _vm._s(row === null || row === void 0 ? void 0 : (_row$data8 = row.data) === null || _row$data8 === void 0 ? void 0 : (_row$data8$value = _row$data8.value) === null || _row$data8$value === void 0 ? void 0 : _row$data8$value.display_name) + "\n      ")])];
      }
    }, {
      key: "space",
      fn: function (row) {
        var _row$data9, _row$data9$value;
        return [_vm._v("\n      " + _vm._s(row === null || row === void 0 ? void 0 : (_row$data9 = row.data) === null || _row$data9 === void 0 ? void 0 : (_row$data9$value = _row$data9.value) === null || _row$data9$value === void 0 ? void 0 : _row$data9$value.length) + "\n    ")];
      }
    }], null, false, 2148286868)
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }